import { P2, P3 } from 'styles';
import { colors } from 'styles/GlobalStyles';
import { Div } from '../../styles/Styles';
import { FooterStyled } from './Footer.styled';

const socialLinks = [
  {
    name: 'Email',
    url: 'support@unitedone.global',
  },
  {
    name: 'Facebook',
    url: 'http://facebook.com/UnitedOne.Global',
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/unitedone.global/',
  },
  {
    name: 'X',
    url: 'https://x.com/united_one48151',
  },
  {
    name: 'YouTube',
    url: 'https://www.youtube.com/@UnitedOne.Global',
  },
];

export const Footer = () => {
  return (
    <FooterStyled>
      <Div
        $flex
        $center
        $gap='100px'
        $gapSM='24px'
        $columnSM
        $mb='50px'
        $p='0 0 50px 0'
        $mbSM='24px'
        $borderBottom='1px solid #fff'
      >
        {socialLinks.map(({ name, url }) => (
          <a
            href={`${name === 'Email' ? `mailto:${url}` : url}`}
            target='_blank'
            rel='noreferrer'
            key={name}
          >
            <P2 color={colors.white}>{name}</P2>
          </a>
        ))}
      </Div>
      <Div
        $flex
        $between
        $alignCenter
        $columnSM
        $gap='30px'
        $gapSM='12px'
        $reverseSM
      >
        <P3 center color={colors.white}>
          © {new Date().getFullYear()} United One. All rights reserved.
        </P3>
        <Div $flex $alignCenter $gap='30px' $gapSM='12px' $columnSM>
          <a
            href={`/terms_of_service_unitedone.pdf`}
            target='_blank'
            rel='noreferrer'
          >
            <P3 color={colors.white}>Terms & Conditions</P3>
          </a>{' '}
          <a
            href={`/privacy_policy_unitedone.pdf`}
            target='_blank'
            rel='noreferrer'
          >
            <P3 color={colors.white}>Privacy policy</P3>
          </a>{' '}
        </Div>
      </Div>
    </FooterStyled>
  );
};
